import AccountService from "@/service/account/accountService";
import BankService from "@/service/bank/bankService";
import ContactService from "@/service/contact/contactService";
import DashBoardService from "@/service/dashBoard/dashBoardService";
import DepartmentService from "@/service/department/departmentService";
import EmployeeService from "@/service/employee/employeeService";
import ExpenseService from "@/service/expense/expenseService";
import ExportService from "@/service/export/exportService";
import MerchantService from "@/service/merchant/merchantService";
import PositionService from "@/service/position/positionService";
import PrivateFileService from "@/service/privateFile/privateFileService";
import RevenueDeductService from "@/service/revenueDeduct/revenueDeductService";
import SalaryService from "@/service/salary/salaryService";
import SettingService from "@/service/setting/settingService";
import StatementService from "@/service/statement/statementService";
import AuthenService from "@/service/user/authenService";
import UserService from "@/service/user/userService";

export default {
  AuthenService,
  AccountService,
  DepartmentService,
  RevenueDeductService,
  PositionService,
  EmployeeService,
  BankService,
  SalaryService,
  StatementService,
  SettingService,
  MerchantService,
  ContactService,
  ExportService,
  UserService,
  DashBoardService,
  PrivateFileService,
  ExpenseService,
};
